import styled from "styled-components";
import {colors} from "nxtconstants";

export const SWP_ACCENT = colors.chartAccent;
export const SWP_ACCENT_TEXT = colors.chartAccentText;

export const CalculatorSection = styled.section`
  padding: 3rem 0;
  background-color: ${colors.white};
  font-family: "Lato";

  @media (max-width: 768px) {
    margin: 0 auto;
  }
`;

export const PageTitle = styled.h1`
  font-size: 4.2rem;
  font-family: "DM Serif Display";
  font-weight: 400;
  color: ${colors.textBlack};
  width: 85%;
  max-width: 125rem;
  margin: 0 auto 4rem;

  @media (max-width: 768px) {
    font-size: 2.4rem;
    line-height: 1.2;
    width: 85%;
    margin: 0 auto 2rem;
    padding: 0;
  }
`;

export const MobileTabContainer = styled.div`
  display: none;
  width: 85%;
  max-width: 125rem;
  margin: 0 auto 2rem;
  border: 1px solid ${colors.lightGray};
  border-radius: 1.2rem;
  overflow: hidden;
  background: ${colors.white};

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const MobileTabButton = styled.button`
  flex: 1;
  border: none;
  cursor: pointer;
  padding: 1.2rem 1.6rem;
  font-family: "Lato";
  font-size: 1.6rem;
  font-weight: 600;
  background: ${(props) => (props.active ? colors.secondary : colors.white)};
  color: ${(props) => (props.active ? colors.textBlack : colors.textGray)};
  transition: background 0.2s ease;

  &:not(:last-child) {
    border-right: 1px solid ${colors.lightGray};
  }
`;

export const CalculatorWrapper = styled.div`
  display: grid;
  grid-template-columns: 42rem 1fr;
  gap: 4rem;
  width: 85%;
  max-width: 125rem;
  margin: 0 auto;
  align-items: start;
  background-color: ${colors.white};
  border: 1px solid ${colors.lightGray};
  border-radius: 2rem;
  padding: 4rem;

  @media (max-width: 850px) {
    grid-template-columns: 1fr;
    gap: 0;
    width: 85%;
    padding: 0;
    background: transparent;
    border: none;
    border-radius: 0;
  }
`;

export const ControlPanel = styled.div`
  @media (max-width: 768px) {
    display: ${(props) => (props.$hidden ? "none" : "block")};
    background-color: ${colors.white};
    padding: 2.4rem;
    width: 100%;
    margin: 0 auto;
    border: 1px solid ${colors.lightGray};
    border-radius: 1.2rem;
  }
`;

export const ResultsPanel = styled.div`
  min-width: 0;
  overflow: hidden;

  @media (max-width: 768px) {
    display: ${(props) => (props.$hidden ? "none" : "block")};
    background-color: ${colors.white};
    padding: 2.4rem;
    width: 100%;
    margin: 0 auto;
    border: 1px solid ${colors.lightGray};
    border-radius: 1.2rem;
  }
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 2rem;
  background-color: ${colors.secondary};
  padding: 2rem 2.4rem;
  border-radius: 1.2rem;
  margin-bottom: 2rem;
  min-width: 0;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    gap: 1.6rem;
    padding: 2rem;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileSummaryCard = styled.div`
  display: none;
  border: 1px solid ${colors.lightGray};
  border-radius: 1.2rem;
  overflow: hidden;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const MobileSummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.4rem 2rem;
  font-size: 1.5rem;
  color: ${colors.textBlack};
  background: ${(props) => (props.$highlight ? colors.secondary : colors.white)};
  border-top: ${(props) => (props.$highlight ? "none" : `1px solid ${colors.lightGray}`)};
  font-weight: 400;

  span:first-child {
    flex-shrink: 0;
    max-width: 45%;
  }

  span:last-child {
    font-weight: 400;
    text-align: right;
    min-width: 0;
    word-break: break-word;
  }
`;

export const SummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  min-width: 0;
`;

export const SummaryLabel = styled.span`
  font-size: 1.8rem;
  color: ${colors.textGray};
  line-height: 1.3;
  word-break: break-word;
`;

export const SummaryValue = styled.span`
  font-size: 2rem;
  font-weight: 400;
  color: ${colors.textBlack};
  line-height: 1.2;
  word-break: break-word;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

export const ViewToggleContainer = styled.div`
  display: inline-flex;
  background: ${colors.secondary};
  border-radius: 5rem;
  padding: 0.4rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    display: flex;
    width: 100%;
  }
`;

export const ViewToggleButton = styled.button`
  border: none;
  cursor: pointer;
  padding: 0.8rem 2rem;
  border-radius: 5rem;
  font-family: "Lato";
  font-size: 1.4rem;
  font-weight: 600;
  background: ${(props) => (props.active ? colors.white : "transparent")};
  color: ${(props) => (props.active ? colors.primary : colors.textGray)};
  box-shadow: ${(props) =>
    props.active ? "0 1px 3px rgba(0, 0, 0, 0.08)" : "none"};

  @media (max-width: 768px) {
    flex: 1;
    text-align: center;
    padding: 1rem;
  }
`;

export const ChartContainer = styled.div`
  width: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    margin: 0 -0.8rem;
    overflow-x: auto;
  }
`;

export const TableWrapper = styled.div`
  width: 100%;
  height: 50rem;
  overflow-x: auto;
  overflow-y: auto;
  border: 1px solid ${colors.lightGray};
  border-radius: 1.2rem;
  -webkit-overflow-scrolling: touch;

  @media (max-width: 768px) {
    height: 36rem;
  }
`;

export const DataTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-family: "Lato";
  font-size: 1.3rem;

  th,
  td {
    padding: 1.2rem 0.8rem;
    text-align: right;
    border-bottom: 1px solid ${colors.lightGray};
    white-space: nowrap;
  }

  th:first-child,
  td:first-child {
    text-align: left;
  }

  th {
    color: ${colors.textGray};
    font-weight: 500;
    background: #fafafa;
    position: sticky;
    top: 0;
    z-index: 1;
    box-shadow: inset 0 -1px 0 ${colors.lightGray};
  }

  td {
    color: ${colors.textBlack};
  }
`;

export const LegendContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 2.4rem;
  padding-top: 1.5rem;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
`;

export const LegendSwatch = styled.div`
  width: 3rem;
  height: 0.5rem;
  background-color: ${(props) => props.color};
  border-radius: 0.6rem;

  @media (max-width: 768px) {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
  }
`;

export const LegendLabel = styled.span`
  margin-left: 1rem;
  font-size: 1.6rem;
  font-family: "Lato";
  color: ${colors.textGray};
`;

export const TooltipTotalRow = styled.p`
  color: #111827;
  margin: 0.8rem 0 0;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
`;
